// 네이버 WCS(웹로그 분석) 추적 — LC 마케팅 사이트 전용.
// src/lib/gtm.ts 패턴 미러링: 지연 스크립트 주입, PROD 게이팅, 홈/마케팅
// 화면(HomeLayout)에서만 로드. 전환은 폼 제출 성공 시 발화
// (사업설명회=custom003, 가맹문의=custom004).

const NAVER_WA = 's_77015768f6b'
const WCS_SRC = 'https://wcs.naver.net/wcslog.js'

// gtm.ts 의 `loaded` 플래그와 동일한 의도: 공통 유입 로그가 여러 번
// 등록/발화되지 않도록 1회로 고정한다.
let inflowLoaded = false

function ensureWcsAdd(): void {
  window.wcs_add = window.wcs_add || {}
  window.wcs_add['wa'] = NAVER_WA
  // _nasa: WCS 커스텀 디멘션 컨테이너. 현재 사용하는 키 없음 — 벤더 스니펫이
  // 요구하는 초기화(빈 객체)만 보장한다.
  window._nasa = window._nasa || {}
}

// wcslog.js 가 준비되면 onReady 를 실행한다.
// <script> 요소는 최대 1개만 생성하고, 로드 리스너는 { once: true } 로
// 등록해 리스너 누수·중복 발화를 막는다.
function whenWcsReady(onReady: () => void): void {
  if (window.wcs) {
    onReady()
    return
  }
  let el = document.querySelector<HTMLScriptElement>(`script[src="${WCS_SRC}"]`)
  if (!el) {
    el = document.createElement('script')
    el.src = WCS_SRC
    el.async = true
    document.head.appendChild(el)
  }
  el.addEventListener('load', onReady, { once: true })
}

/** 공통 유입(inflow) 로그. 홈/마케팅 화면에서 1회 호출. */
export function loadNaverWcs(): void {
  if (!import.meta.env.PROD) return
  if (inflowLoaded) return
  inflowLoaded = true
  whenWcsReady(() => {
    ensureWcsAdd()
    window.wcs?.inflow()
    window.wcs_do?.()
  })
}

/** 마케팅 폼 제출 성공 시 발화하는 전환 로그. */
export function trackNaverConversion(type: 'custom003' | 'custom004'): void {
  if (!import.meta.env.PROD) return
  whenWcsReady(() => {
    ensureWcsAdd()
    window.wcs?.trans({ type })
  })
}

/** @internal 테스트 전용 — 모듈 상태 초기화. */
export function __resetNaverState(): void {
  inflowLoaded = false
}
